import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WhatsappContactsResponse } from 'src/app/models/bot.interface';
import { UpdateAttentionSchedulePayload } from 'src/app/models/attention-schedule.interface';

@Injectable({
  providedIn: 'root',
})
export class WhatsappBotService {
  apiAddress: string = environment.apiAddress;

  constructor(private http: HttpClient) {}

  postBotWhatsapp(
    botId: string,
    phoneNumber: string,
    whatsapp_token: string,
    graphUrl: string,
    isEnabled: boolean
  ) {
    return this.http.post<any>(`${this.apiAddress}/bot/${botId}/whatsapp_bot`, {
      phone_number: phoneNumber,
      whatsapp_token: whatsapp_token,
      whatsapp_endpoint: graphUrl,
      is_enabled: isEnabled,
    });
  }
  getBotWhatsapp(botId: string) {
    return this.http.get<any>(`${this.apiAddress}/bot/${botId}/whatsapp_bot`);
  }

  deleteBotWhatsapp(botId: string) {
    return this.http.delete<any>(`${this.apiAddress}/bot/${botId}/whatsapp_bot`);
  }
  updateBotWhatsapp(
    botId: string,
    phoneNumber: string,
    whatsapp_token: string,
    graphUrl: string,
    isEnabled: boolean
  ) {
    const body: Record<string, unknown> = {
      is_enabled: isEnabled,
    };
    if (phoneNumber !== undefined && phoneNumber !== null) {
      body['phone_number'] = phoneNumber;
    }
    if (whatsapp_token !== undefined && whatsapp_token !== null) {
      body['whatsapp_token'] = whatsapp_token;
    }
    if (graphUrl !== undefined && graphUrl !== null) {
      body['whatsapp_endpoint'] = graphUrl;
    }
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/whatsapp_bot`, body);
  }

  updateAttentionSchedule(botId: string, payload: UpdateAttentionSchedulePayload) {
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/whatsapp_bot`, payload);
  }

  getRecentContacts(
    botId: string,
    init: string,
    term: string,
    page: number = 1,
    pageSize: number = 5
  ): Observable<WhatsappContactsResponse> {
    const params = new HttpParams()
      .set('init', init)
      .set('term', term)
      .set('page', page)
      .set('page_size', pageSize);
    return this.http.get<WhatsappContactsResponse>(
      `${this.apiAddress}/bot/${botId}/whatsapp_bot/contacts`,
      { params }
    );
  }

  completeEmbeddedSignup(
    botId: string,
    payload: {
      code: string;
      redirect_uri?: string;
      phone_number_id?: string;
      waba_id?: string;
    }
  ) {
    return this.http.post<any>(
      `${this.apiAddress}/bot/${botId}/whatsapp_bot/embedded-signup/complete`,
      payload
    );
  }
}
